import React from "react";
import { ListItem } from "../core/pdf/types";
import { useDesigner } from "./useDesigner";
import { useList } from "./useList";
import { ListItemContext, useListItem } from "./useListItem";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { toMillimeters } from "../core/pdf/utils";
import { ContentItems } from "./ContentItems";
import { formatListNumber } from "../formatters/format";

export function ListItemEditor(props: {
	item: ListItem,
	number: number,
}) {
	const designer = useDesigner();

	const listState = useList();
	const list = listState!.list;

	const parentListItem = useListItem();

	const listItemState = React.useMemo(() => {
		return {
			item: props.item, 
			number: formatListNumber(props.number, listState!.style, (parentListItem) ? parentListItem.number : ""),
		}
	}, [props.item, props.number, listState!.style]);

	const elementContext = useElementContext(props.item);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {
		
	}, []));

	const numberStyle = {
		width: toMillimeters(list.indent ? list.indent : designer.structure.defaults.listIndent) + "mm",
	};

	const contentStyle = {};
	if (list.itemMargin) {
		designer.updateStyleMargin(contentStyle, list.itemMargin)
	}

	return (
		<ElementContext.Provider value={elementContext}>
			<ListItemContext.Provider value={listItemState}>
				<div
					className={"list-item-editor content-element flex align-start " + state.classes}
					data-key={props.item.id}
					id={state.elementID}
					>
					<div style={numberStyle}>
						{listItemState.number}
					</div>
					<div style={contentStyle} className="fill">
						<ContentItems
							content={props.item.content}
						/>
					</div>
				</div>
			</ListItemContext.Provider>
		</ElementContext.Provider>
	)
}